import styled from "styled-components";
interface SummaryCardProps {
  bg?: string;
}

export const Container = styled.div`
  width: 100%; 
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const WalletHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BalanceCard = styled.div`
  background: linear-gradient(135deg, #3ac77e, #23a55c);
  border-radius: 16px;
  padding: 2rem;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .label {
    font-size: 0.9rem;
    opacity: 0.9;
  }
  h2 {
    font-size: 2.5rem;
    margin: 0.3rem 0;
  }
  .name {
    font-size: 1rem;
    opacity: 0.8;
  }
`;

export const SummaryCards = styled.div`
  display: flex;
  gap: 1rem; 
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;


export const SummaryCard = styled.div<SummaryCardProps>`
  /* background: ${(props) => props.bg || "#f5f5f5"}; */
  background-color: white;
  box-shadow: 10px;
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  width: 100%;
  height: 150px;
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  p {
    margin: 0;
    font-size: 24px;
    opacity: 0.8;

  }
  h3 {
    font-size: 20px;
    margin-top: 0.4rem;
  }
`;

export const Transactions = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;


  h2 {
    font-size: 24px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  .see-all {
    font-size: 0.9rem;
    color: #23a55c;
    cursor: pointer;
  }
`;

export const TransactionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;
  border-bottom: 1px solid #eee;

  .title {
    font-weight: 500;
    font-size: 14px;
  }
  .date {
    font-size: 14px;
    opacity: 0.6;
  }
  .amount {
    font-weight: bold;
  }
  .red {
    color: #e74c3c;
  }
`;

/* Responsive */
// @media (max-width: 768px) {
//   ${BalanceCard} {
//     flex-direction: column;
//     text-align: center;
//   }
//   ${SummaryCards} {
//     flex-direction: column;
//   }
// }
